import aImportSalarisCSVImportInitieel from '../aImportSalarisCSV/importInitieel.js';

const importInitieel = {

	init: function() {
		aImportSalarisCSVImportInitieel.init();
	}

};

export default importInitieel;
